//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import { Route, Routes } from 'react-router-dom';
import DemoPage from './pages/DemoPage';
import HomePage from './pages/HomePage';

//---------------------------------------------------------
// Component
//---------------------------------------------------------
export default function AppRoot() {
	return (
		<Routes>
			<Route path="/" element={<DemoPage />} />
			<Route path="/demo" element={<DemoPage />} />
			<Route path="/home" element={<HomePage />} />
			<Route path="*" element={<DemoPage />} />
		</Routes>
	);
}
